export default __webpack_public_path__ + "static/media/MUST.a7698d74.png";